import React from 'react';

const CombinedEffects = () => {
  return (
    <>
      {/* <MouseTrackingEffect /> */}
      {/* <FloatingOrbs /> */}
      {/* <GlitchEffect /> */}
      {/* <ScanlineEffect /> */}
    </>
  );
};

export default CombinedEffects;